import React from "react";

import { Chip, ChipPropsColorOverrides, Tooltip } from "@mui/material";
import { OverridableStringUnion } from "@mui/types";

import { errorCodeMappings } from "../../services/api/Jobs";
import { TaskStatus as TaskStatusEnum } from "../../services/utils/status";

type StatusDetails = {
  color: OverridableStringUnion<
    "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning",
    ChipPropsColorOverrides
  >;
};

const STATUSES: { [key in TaskStatusEnum]: StatusDetails } = {
  [TaskStatusEnum.SUBMITTED]: { color: "default" },
  [TaskStatusEnum.PROGRESSING]: { color: "default" },
  [TaskStatusEnum.COMPLETE]: { color: "info" },
  [TaskStatusEnum.REGISTERED]: { color: "success" },
  [TaskStatusEnum.DEPRECATED]: { color: "default" },
  [TaskStatusEnum.CANCELED]: { color: "error" },
  [TaskStatusEnum.FAILED]: { color: "warning" },
  [TaskStatusEnum.ERROR]: { color: "error" },
  [TaskStatusEnum.INACTIVE]: { color: "dark" },
};

function getErrorMessage(errorType: string): string {
  if (!errorType) return "";

  return errorCodeMappings[errorType] || "Unknown error";
}

const TaskStatus: React.FC<{ status: TaskStatusEnum; errorType?: string }> = ({ status, errorType }) => {
  const statusDetails = STATUSES[status];
  const chip = (
    <Chip
      size="small"
      label={status}
      sx={{ lineHeight: "normal", minWidth: "110px", fontWeight: "bold" }}
      color={statusDetails?.color}
    />
  );

  return status === TaskStatusEnum.ERROR && errorType ? (
    <Tooltip data-testid="task-error-message" title={getErrorMessage(errorType)}>
      {chip}
    </Tooltip>
  ) : (
    chip
  );
};

export default TaskStatus;
